import Vue from "vue";
import App from "./App.vue";
import router from "./plugins/router";
import store from "./plugins/store";
// import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "vue-awesome/icons/home";
import "vue-awesome/icons/power-off";
/////// rozenbal /////
import "vue-awesome/icons/times";
import "vue-awesome/icons/archive";
import "vue-awesome/icons/box-open";
import "vue-awesome/icons/hand-paper";
import "vue-awesome/icons/download";
import "vue-awesome/icons/list";
import "vue-awesome/icons/print";
import "vue-awesome/icons/question-circle";
import "vue-awesome/icons/exclamation-triangle";
import "vue-awesome/icons/angle-double-left";
import "vue-awesome/icons/angle-left";
import "vue-awesome/icons/angle-double-right";
import "vue-awesome/icons/angle-right";
import "vue-awesome/icons/copy";
import "vue-awesome/icons/file-excel";
import "vue-awesome/icons/user-circle";
import "vue-awesome/icons/trash";
import "vue-awesome/icons/plus";
import "vue-awesome/icons/rocket";
import "vue-awesome/icons/user";
import "vue-awesome/icons/file-alt";
import "vue-awesome/icons/eye";
import "vue-awesome/icons/edit";
import "vue-awesome/icons/caret-down";
import "vue-awesome/icons/caret-right";
import "vue-awesome/icons/eye-slash";
import "vue-awesome/icons/arrow-circle-right";
import "vue-awesome/icons/folder";
import "vue-awesome/icons/folder-open";
import Icon from "vue-awesome/components/Icon";
Vue.component("Icon", Icon);
import moment from "moment";
// Importing the global css file
import "@/sass/main.scss";

moment.locale("fr");
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
// import jquery from "jquery";
// Object.defineProperty(Vue.prototype, "$jquery", { value: jquery });
import axios from "axios";
Object.defineProperty(Vue.prototype, "$axios", { value: axios });
axios.defaults.headers.common["x-auth-apikey"] = store.state.token;
axios.interceptors.response.use(
  function(response) {
    let ok = true;
    if (response.data && response.data.err) {
      //console.log("response.data.err", response.data.err);
      if (
        response.data.err.key == "token_mandatory" ||
        response.data.err.key == "user_not_found"
      )
        ok = false;
    }
    // console.error("response.data.err", ok, response.data.err);
    if (!ok) {
      router.push("/");
      // return Promise.reject(response);
    }
    return response;
  },
  function(error) {
    console.error("response error", error);
    return Promise.reject(error);
  }
);

import _ from "lodash";
Object.defineProperty(Vue.prototype, "$_", { value: _ });
import config from "./config.js";
Object.defineProperty(Vue.prototype, "$config", { value: config });
import Utils from "./plugins/utils.js";
Object.defineProperty(Vue.prototype, "$Utils", { value: Utils });
import Validation from "./plugins/validation.js";
Object.defineProperty(Vue.prototype, "$Validation", { value: Validation });

var numeral = require("numeral");
numeral.register("locale", "fr", {
  delimiters: {
    thousands: ".",
    decimal: ","
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t"
  },
  ordinal: function(number) {
    return number === 1 ? "er" : "ème";
  },
  currency: {
    symbol: "€"
  }
});
numeral.locale("fr");

Vue.config.productionTip = true;

import "./plugins/filters";
import "./plugins/components";

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
